export const PHONE_COUNTRIES = [
  { id: "US", fullName: "United States", startNumber: "+1" },
  { id: "TD", fullName: "Chad", startNumber: "+235" },
  { id: "TG", fullName: "Togo", startNumber: "+228" },
  { id: "TH", fullName: "Thailand", startNumber: "+66" },
  { id: "TJ", fullName: "Tajikistan", startNumber: "+992" },
  { id: "TK", fullName: "Tokelau", startNumber: "+690" },
  { id: "TL", fullName: "Timor-Leste", startNumber: "+670" },
  { id: "TM", fullName: "Turkmenistan", startNumber: "+993" },
  { id: "TN", fullName: "Tunisia", startNumber: "+216" },
  { id: "TO", fullName: "Tonga", startNumber: "+676" },
  { id: "TR", fullName: "Turkey", startNumber: "+90" },
  { id: "TT", fullName: "Trinidad and Tobago", startNumber: "+1-868" },
  { id: "TV", fullName: "Tuvalu", startNumber: "+688" },
  { id: "TW", fullName: "Taiwan", startNumber: "+886" },
  { id: "TZ", fullName: "Tanzania", startNumber: "+255" },
  { id: "UA", fullName: "Ukraine", startNumber: "+380" },
  { id: "UG", fullName: "Uganda", startNumber: "+256" },
  { id: "UY", fullName: "Uruguay", startNumber: "+598" },
  { id: "UZ", fullName: "Uzbekistan", startNumber: "+998" },
  { id: "VA", fullName: "Vatican City", startNumber: "+379" },
  { id: "VC", fullName: "Saint Vincent and the Grenadines", startNumber: "+1-784" },
  { id: "VE", fullName: "Venezuela", startNumber: "+58" },
  { id: "VG", fullName: "British Virgin Islands", startNumber: "+1-284" },
  { id: "VI", fullName: "U.S. Virgin Islands", startNumber: "+1-340" },
  { id: "VN", fullName: "Vietnam", startNumber: "+84" },
  { id: "VU", fullName: "Vanuatu", startNumber: "+678" },
  { id: "WF", fullName: "Wallis and Futuna", startNumber: "+681" },
  { id: "NL", fullName: "Netherlands", startNumber: "+31" },
  { id: "NO", fullName: "Norway", startNumber: "+47" },
  { id: "NP", fullName: "Nepal", startNumber: "+977" },
  { id: "NR", fullName: "Nauru", startNumber: "+674" },
  { id: "NU", fullName: "Niue", startNumber: "+683" },
  { id: "NZ", fullName: "New Zealand", startNumber: "+64" },
  { id: "OM", fullName: "Oman", startNumber: "+968" },
  { id: "PA", fullName: "Panama", startNumber: "+507" },
  { id: "PE", fullName: "Peru", startNumber: "+51" },
  { id: "PF", fullName: "French Polynesia", startNumber: "+689" },
  { id: "PG", fullName: "Papua New Guinea", startNumber: "+675" },
  { id: "PH", fullName: "Philippines", startNumber: "+63" },
  { id: "PK", fullName: "Pakistan", startNumber: "+92" },
  { id: "PL", fullName: "Poland", startNumber: "+48" },
  { id: "PM", fullName: "Saint Pierre and Miquelon", startNumber: "+508" },
  { id: "PR", fullName: "Puerto Rico", startNumber: "+1-787" },
  { id: "PS", fullName: "Palestinian Territories", startNumber: "+970" },
  { id: "PT", fullName: "Portugal", startNumber: "+351" },
  { id: "PW", fullName: "Palau", startNumber: "+680" },
  { id: "PY", fullName: "Paraguay", startNumber: "+595" },
  { id: "QA", fullName: "Qatar", startNumber: "+974" },
  { id: "RE", fullName: "Réunion", startNumber: "+262" },
  { id: "RO", fullName: "Romania", startNumber: "+40" },
  { id: "RS", fullName: "Serbia", startNumber: "+381" },
  { id: "RU", fullName: "Russia", startNumber: "+7" },
  { id: "RW", fullName: "Rwanda", startNumber: "+250" },
  { id: "SA", fullName: "Saudi Arabia", startNumber: "+966" },
  { id: "SB", fullName: "Solomon Islands", startNumber: "+677" },
  { id: "SC", fullName: "Seychelles", startNumber: "+248" },
  { id: "SD", fullName: "Sudan", startNumber: "+249" },
  { id: "SE", fullName: "Sweden", startNumber: "+46" },
  { id: "SG", fullName: "Singapore", startNumber: "+65" },
  { id: "SH", fullName: "Saint Helena", startNumber: "+290" },
  { id: "SI", fullName: "Slovenia", startNumber: "+386" },
  { id: "SJ", fullName: "Svalbard and Jan Mayen", startNumber: "+47" },
  { id: "SK", fullName: "Slovakia", startNumber: "+421" },
  { id: "SL", fullName: "Sierra Leone", startNumber: "+232" },
  { id: "SM", fullName: "San Marino", startNumber: "+378" },
  { id: "SN", fullName: "Senegal", startNumber: "+221" },
  { id: "SO", fullName: "Somalia", startNumber: "+252" },
  { id: "SR", fullName: "Suriname", startNumber: "+597" },
  { id: "SS", fullName: "South Sudan", startNumber: "+211" },
  { id: "ST", fullName: "São Tomé and Príncipe", startNumber: "+239" },
  { id: "SV", fullName: "El Salvador", startNumber: "+503" },
  { id: "SX", fullName: "Sint Maarten", startNumber: "+1-721" },
  { id: "SY", fullName: "Syria", startNumber: "+963" },
  { id: "LU", fullName: "Luxembourg", startNumber: "+352" },
  { id: "LV", fullName: "Latvia", startNumber: "+371" },
  { id: "LY", fullName: "Libya", startNumber: "+218" },
  { id: "MA", fullName: "Morocco", startNumber: "+212" },
  { id: "MC", fullName: "Monaco", startNumber: "+377" },
  { id: "MD", fullName: "Moldova", startNumber: "+373" },
  { id: "ME", fullName: "Montenegro", startNumber: "+382" },
  { id: "MF", fullName: "Saint Martin", startNumber: "+590" },
  { id: "MG", fullName: "Madagascar", startNumber: "+261" },
  { id: "MH", fullName: "Marshall Islands", startNumber: "+692" },
  { id: "MK", fullName: "North Macedonia", startNumber: "+389" },
  { id: "ML", fullName: "Mali", startNumber: "+223" },
  { id: "MM", fullName: "Myanmar", startNumber: "+95" },
  { id: "MN", fullName: "Mongolia", startNumber: "+976" },
  { id: "MO", fullName: "Macao", startNumber: "+853" },
  { id: "MP", fullName: "Northern Mariana Islands", startNumber: "+1-670" },
  { id: "MQ", fullName: "Martinique", startNumber: "+596" },
  { id: "MR", fullName: "Mauritania", startNumber: "+222" },
  { id: "MS", fullName: "Montserrat", startNumber: "+1-664" },
  { id: "MT", fullName: "Malta", startNumber: "+356" },
  { id: "MU", fullName: "Mauritius", startNumber: "+230" },
  { id: "MV", fullName: "Maldives", startNumber: "+960" },
  { id: "MW", fullName: "Malawi", startNumber: "+265" },
  { id: "MX", fullName: "Mexico", startNumber: "+52" },
  { id: "GN", fullName: "Guinea", startNumber: "+224" },
  { id: "GP", fullName: "Guadeloupe", startNumber: "+590" },
  { id: "GQ", fullName: "Equatorial Guinea", startNumber: "+240" },
  { id: "GR", fullName: "Greece", startNumber: "+30" },
  { id: "GT", fullName: "Guatemala", startNumber: "+502" },
  { id: "GU", fullName: "Guam", startNumber: "+1-671" },
  { id: "GW", fullName: "Guinea-Bissau", startNumber: "+245" },
  { id: "GY", fullName: "Guyana", startNumber: "+592" },
  { id: "HK", fullName: "Hong Kong", startNumber: "+852" },
  { id: "HN", fullName: "Honduras", startNumber: "+504" },
  { id: "HR", fullName: "Croatia", startNumber: "+385" },
  { id: "HT", fullName: "Haiti", startNumber: "+509" },
  { id: "HU", fullName: "Hungary", startNumber: "+36" },
  { id: "ID", fullName: "Indonesia", startNumber: "+62" },
  { id: "IE", fullName: "Ireland", startNumber: "+353" },
  { id: "IL", fullName: "Israel", startNumber: "+972" },
  { id: "IM", fullName: "Isle of Man", startNumber: "+44-1624" },
  { id: "IN", fullName: "India", startNumber: "+91" },
  { id: "IO", fullName: "British Indian Ocean Territory", startNumber: "+246" },
  { id: "IQ", fullName: "Iraq", startNumber: "+964" },
  { id: "IR", fullName: "Iran", startNumber: "+98" },
  { id: "IS", fullName: "Iceland", startNumber: "+354" },
  { id: "IT", fullName: "Italy", startNumber: "+39" },
  { id: "JE", fullName: "Jersey", startNumber: "+44-1534" },
  { id: "JM", fullName: "Jamaica", startNumber: "+1-876" },
  { id: "JO", fullName: "Jordan", startNumber: "+962" },
  { id: "JP", fullName: "Japan", startNumber: "+81" },
  { id: "CR", fullName: "Costa Rica", startNumber: "+506" },
  { id: "CU", fullName: "Cuba", startNumber: "+53" },
  { id: "CV", fullName: "Cabo Verde", startNumber: "+238" },
  { id: "CW", fullName: "Curaçao", startNumber: "+599" },
  { id: "BI", fullName: "Burundi", startNumber: "+257" },
  { id: "BJ", fullName: "Benin", startNumber: "+229" },
  { id: "BL", fullName: "Saint Barthélemy", startNumber: "+590" },
  { id: "BM", fullName: "Bermuda", startNumber: "+1-441" },
  { id: "BN", fullName: "Brunei Darussalam", startNumber: "+673" },
  { id: "BO", fullName: "Bolivia", startNumber: "+591" },
  { id: "BQ", fullName: "Bonaire, Sint Eustatius and Saba", startNumber: "+599" },
  { id: "BR", fullName: "Brazil", startNumber: "+55" },
  { id: "BS", fullName: "Bahamas", startNumber: "+1-242" },
  { id: "BT", fullName: "Bhutan", startNumber: "+975" },
  { id: "BW", fullName: "Botswana", startNumber: "+267" },
  { id: "BY", fullName: "Belarus", startNumber: "+375" },
  { id: "AD", fullName: "Andorra", startNumber: "+376" },
  { id: "AE", fullName: "United Arab Emirates", startNumber: "+971" },
  { id: "AF", fullName: "Afghanistan", startNumber: "+93" },
  { id: "AG", fullName: "Antigua and Barbuda", startNumber: "+1-268" },
  { id: "AI", fullName: "Anguilla", startNumber: "+1-264" },
  { id: "AL", fullName: "Albania", startNumber: "+355" },
  { id: "AM", fullName: "Armenia", startNumber: "+374" },
  { id: "AO", fullName: "Angola", startNumber: "+244" },
  { id: "AR", fullName: "Argentina", startNumber: "+54" },
  { id: "AS", fullName: "American Samoa", startNumber: "+1-684" },
  { id: "AT", fullName: "Austria", startNumber: "+43" },
  { id: "AU", fullName: "Australia", startNumber: "+61" },
  { id: "AW", fullName: "Aruba", startNumber: "+297" },
  { id: "AX", fullName: "Åland Islands", startNumber: "+358" },
  { id: "AZ", fullName: "Azerbaijan", startNumber: "+994" },
  { id: "BA", fullName: "Bosnia and Herzegovina", startNumber: "+387" },
  { id: "BB", fullName: "Barbados", startNumber: "+1-246" },
  { id: "BD", fullName: "Bangladesh", startNumber: "+880" },
  { id: "BE", fullName: "Belgium", startNumber: "+32" },
  { id: "BF", fullName: "Burkina Faso", startNumber: "+226" },
  { id: "BG", fullName: "Bulgaria", startNumber: "+359" },
  { id: "BH", fullName: "Bahrain", startNumber: "+973" },
  { id: "BZ", fullName: "Belize", startNumber: "+501" },
  { id: "CA", fullName: "Canada", startNumber: "+1" },
  { id: "CC", fullName: "Cocos (Keeling) Islands", startNumber: "+61" },
  { id: "CD", fullName: "Democratic Republic of the Congo", startNumber: "+243" },
  { id: "CF", fullName: "Central African Republic", startNumber: "+236" },
  { id: "CG", fullName: "Republic of the Congo", startNumber: "+242" },
  { id: "CH", fullName: "Switzerland", startNumber: "+41" },
  { id: "CI", fullName: "Ivory Coast", startNumber: "+225" },
  { id: "CK", fullName: "Cook Islands", startNumber: "+682" },
  { id: "CL", fullName: "Chile", startNumber: "+56" },
  { id: "CM", fullName: "Cameroon", startNumber: "+237" },
  { id: "CN", fullName: "China", startNumber: "+86" },
  { id: "CO", fullName: "Colombia", startNumber: "+57" },
  { id: "CX", fullName: "Christmas Island", startNumber: "+61" },
  { id: "CY", fullName: "Cyprus", startNumber: "+357" },
  { id: "CZ", fullName: "Czech Republic", startNumber: "+420" },
  { id: "DE", fullName: "Germany", startNumber: "+49" },
  { id: "DJ", fullName: "Djibouti", startNumber: "+253" },
  { id: "DK", fullName: "Denmark", startNumber: "+45" },
  { id: "DM", fullName: "Dominica", startNumber: "+1-767" },
  { id: "DO", fullName: "Dominican Republic", startNumber: "+1-809" },
  { id: "DZ", fullName: "Algeria", startNumber: "+213" },
  { id: "EC", fullName: "Ecuador", startNumber: "+593" },
  { id: "EE", fullName: "Estonia", startNumber: "+372" },
  { id: "EG", fullName: "Egypt", startNumber: "+20" },
  { id: "EH", fullName: "Western Sahara", startNumber: "+212" },
  { id: "ER", fullName: "Eritrea", startNumber: "+291" },
  { id: "ES", fullName: "Spain", startNumber: "+34" },
  { id: "ET", fullName: "Ethiopia", startNumber: "+251" },
  { id: "KE", fullName: "Kenya", startNumber: "+254" },
  { id: "KG", fullName: "Kyrgyzstan", startNumber: "+996" },
  { id: "FI", fullName: "Finland", startNumber: "+358" },
  { id: "FJ", fullName: "Fiji", startNumber: "+679" },
  { id: "FK", fullName: "Falkland Islands", startNumber: "+500" },
  { id: "FM", fullName: "Federated States of Micronesia", startNumber: "+691" },
  { id: "FO", fullName: "Faroe Islands", startNumber: "+298" },
  { id: "FR", fullName: "France", startNumber: "+33" },
  { id: "GA", fullName: "Gabon", startNumber: "+241" },
  { id: "GB", fullName: "United Kingdom", startNumber: "+44" },
  { id: "GD", fullName: "Grenada", startNumber: "+1-473" },
  { id: "GE", fullName: "Georgia", startNumber: "+995" },
  { id: "GF", fullName: "French Guiana", startNumber: "+594" },
  { id: "GG", fullName: "Guernsey", startNumber: "+44-1481" },
  { id: "GH", fullName: "Ghana", startNumber: "+233" },
  { id: "GI", fullName: "Gibraltar", startNumber: "+350" },
  { id: "GL", fullName: "Greenland", startNumber: "+299" },
  { id: "GM", fullName: "Gambia", startNumber: "+220" },
  { id: "KH", fullName: "Cambodia", startNumber: "+855" },
  { id: "KI", fullName: "Kiribati", startNumber: "+686" },
  { id: "KM", fullName: "Comoros", startNumber: "+269" },
  { id: "KN", fullName: "Saint Kitts and Nevis", startNumber: "+1-869" },
  { id: "KP", fullName: "North Korea", startNumber: "+850" },
  { id: "KR", fullName: "South Korea", startNumber: "+82" },
  { id: "KW", fullName: "Kuwait", startNumber: "+965" },
  { id: "KY", fullName: "Cayman Islands", startNumber: "+1-345" },
  { id: "KZ", fullName: "Kazakhstan", startNumber: "+7" },
  { id: "LA", fullName: "Laos", startNumber: "+856" },
  { id: "LB", fullName: "Lebanon", startNumber: "+961" },
  { id: "LC", fullName: "Saint Lucia", startNumber: "+1-758" },
  { id: "LI", fullName: "Liechtenstein", startNumber: "+423" },
  { id: "LK", fullName: "Sri Lanka", startNumber: "+94" },
  { id: "LR", fullName: "Liberia", startNumber: "+231" },
  { id: "LS", fullName: "Lesotho", startNumber: "+266" },
  { id: "LT", fullName: "Lithuania", startNumber: "+370" },
  { id: "MY", fullName: "Malaysia", startNumber: "+60" },
  { id: "MZ", fullName: "Mozambique", startNumber: "+258" },
  { id: "NA", fullName: "Namibia", startNumber: "+264" },
  { id: "NC", fullName: "New Caledonia", startNumber: "+687" },
  { id: "NE", fullName: "Niger", startNumber: "+227" },
  { id: "NF", fullName: "Norfolk Island", startNumber: "+672" },
  { id: "NG", fullName: "Nigeria", startNumber: "+234" },
  { id: "NI", fullName: "Nicaragua", startNumber: "+505" },
  { id: "SZ", fullName: "Eswatini", startNumber: "+268" },
  { id: "TA", fullName: "Tristan da Cunha", startNumber: "+290" },
  { id: "TC", fullName: "Turks and Caicos Islands", startNumber: "+1-649" },
  { id: "WS", fullName: "Samoa", startNumber: "+685" },
  { id: "XK", fullName: "Kosovo", startNumber: "+383" },
  { id: "YE", fullName: "Yemen", startNumber: "+967" },
  { id: "YT", fullName: "Mayotte", startNumber: "+262" },
  { id: "ZA", fullName: "South Africa", startNumber: "+27" },
  { id: "ZM", fullName: "Zambia", startNumber: "+260" },
  { id: "ZW", fullName: "Zimbabwe", startNumber: "+263" },
];
